module.exports = __webpack_public_path__ + "media/Video (4).0baa3787.mp4";